import React from 'react';
import { TrendingUp } from 'lucide-react';

interface Track {
  id: string;
  title: string;
  artist: string;
  plays: number;
  coverGradient: string;
  cover: string;
  trending: boolean;
}

function formatNum(n: number): string {
  if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
  return n.toString();
}

export default function TrendingSidebar({ tracks }: { tracks: Track[] }) {
  const trending = tracks.filter(t => t.trending).slice(0, 6);

  return (
    <div className="glass-card rounded-xl p-4">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp size={16} style={{ color: 'var(--primary)' }} />
        <p className="font-semibold text-sm">Trending Now</p>
      </div>
      <div className="space-y-3">
        {trending.map((track, i) => (
          <div key={track.id} className="flex items-center gap-3 group cursor-pointer hover:bg-muted/50 rounded-lg p-2 -mx-2 transition-colors">
            <span className="text-xs font-bold tabular-nums w-4 flex-shrink-0"
              style={{ color: i < 3 ? 'var(--primary)' : 'var(--muted-foreground)' }}>
              {i + 1}
            </span>
            <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 text-xs font-bold text-white"
              style={{ background: track.coverGradient }}>
              {track.cover}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold truncate">{track.title}</p>
              <p className="text-xs truncate" style={{ color: 'var(--muted-foreground)' }}>{track.artist}</p>
            </div>
            <span className="text-xs tabular-nums flex-shrink-0" style={{ color: 'var(--muted-foreground)' }}>
              {formatNum(track.plays)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}